import {createStyles} from '@mantine/core';
import classNames from 'classnames';
import createReactClass from 'create-react-class';
import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {PERMISSIONS_SHAPE} from 'auth/PermissionConstants';
import {AvScanStatus, AV_SCAN_TERMINAL_STATUSES, getScanStatus} from 'av-scan/AvScanDAO';
import BenchlingConfig from 'BenchlingConfig';
import * as benchlingUtil from 'BenchlingUtil';
import {CHEMICAL_EXTENSIONS} from 'chemistry/ChemistryConstants';
import {detectReaction} from 'chemistry/molecules/MoleculeUtil';
import * as contextmenu from 'components/ContextMenu';
import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import * as context from 'Context';
import SignedExtFileURLProxy from 'external-files/SignedExtFileURLProxy';
import * as ToastActions from 'nav/toasts/ToastActions';
import {ToastType} from 'nav/toasts/ToastConstants';
import {CaptionEditableItemContext} from 'notebook/mediocre/base-plugin/CaptionEditableItemContext';
import * as MediocreConstants from 'notebook/mediocre/MediocreConstants';
import FileExcerptModalClass from 'notebook/notes/attachments/excerpts/FileExcerptModal';
import ImageEditorWrapper from 'notebook/notes/attachments/images/ImageEditorWrapper';
import ImageToolbar from 'notebook/notes/attachments/images/ImageToolbar';
import openURIForEdit from 'notebook/notes/attachments/local-sync/openURIForEdit';
import * as NoteLinkedFileTab from 'notebook/notes/attachments/NoteLinkedFileTab';
import {getTFIFileMeta, isLocalSyncFile} from 'notebook/notes/attachments/NoteLinkedFileUtil';
import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';
import NoteConstants from 'notebook/notes/NoteConstants';
import PreviewMixin, {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import {ACTION_CHECKOUT_FILE, ACTION_SYNC_FILE} from 'notebook/store/VersioningConstants';
import {TFI_ACCOUNT_SHAPE} from 'notebook/tfi/TFIAccountItem';
import TFIActions from 'notebook/tfi/TFIActions';
import {TFIFileMeta, TFIFileMetaState} from 'notebook/tfi/TFIConstants';
import {confirmTFIUnlock, isCurrentUserLocalSyncFile} from 'notebook/tfi/TFIFileSync';
import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';
import {ExternalFileExcerpt, FromServerNoteLinkedFile, NoteLinkedFile} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import DocumentEditorLockUtil from 'realtime/util/DocumentEditorLockUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {COLORS} from 'ui-library/ColorPickerConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import BenchlingIcon, {BenchlingIconProps} from 'ui-library/icons/BenchlingIcon';
import legacyRunModal from 'ui-library/legacyRunModal';
import ModalAnchor from 'ui-library/ModalAnchor';
import Modal from 'ui-library/modals/Modal';
import fuzzydate from 'util/fuzzydate';
import * as Logging from 'util/Logging';
import * as modals from 'util/Modals';
import uniqueId from 'util/uniqueId';

import DownloadChemicalModal from './molecules/DownloadChemicalModal';
import {chemicalStructureFromFile} from './molecules/MoleculeUtil';
import StructureSketcherTool from './molecules/StructureSketcherTool';
import * as NoteLinkedFileDAO from './NoteLinkedFileDAO';
import useTFIFileMetaState from './useTFIFileMetaState';

/*
 * There are two cases in which the NoteLinkedFilePreview can be used:
 *
 *   1. With note linked file data
 *   2. With a task id and task of a currently (or finished) uploading note linked object
 *
 */

const {MEDIOCRE_TOTAL_IMAGE_PADDING} = MediocreConstants;

const {MAX_NAME_LENGTH, NOTE_LINKED_FILE} = NoteConstants;

const ONE_MEGABYTE = 1024 * 1024;
const MAX_FILE_SIZE_FOR_PREVIEW_BYTES = 100 * ONE_MEGABYTE;
const SCAN_POLL_BASE_DELAY_MS = 2500;
const SCAN_POLL_MAX_DELAY_MS = 15000;
const SCAN_POLL_ERROR_LOG_THRESHOLD = 10;

interface PreviewExternalFile {
  id?: string;
  url: string;
  fileSize?: number;
  previewType?: string | null;
}

interface NoteLinkedFilePreviewItem {
  cid: string;
  name: string;
  documentType?: string;
  editURL?: string;
  url?: string;
  tagSchema?: {iconId: string} | null;
  excerptType?: string | null;
  externalFile?: PreviewExternalFile | null;
  externalFileExcerpt?: {
    id?: string;
    excerptFile: PreviewExternalFile;
    referenceOffset?: number;
  } | null;
  previewFile?: PreviewExternalFile | null;
  missingPreviewWarning?: string | null;
  isPreviewTransformed?: boolean | null;
  tfiFileMeta?: TFIFileMeta | null;
  sourcePreviewFile?: PreviewExternalFile | null;
  edits?: string;
  scanId?: string;
  scanStatus?: string | null;
}

interface NoteLinkedFilePreviewOwnProps extends Omit<
  PreviewProps,
  'finalizeItemWidth' | 'item' | 'setItemWidth'
> {
  previewFileId?: string;
  item?: NoteLinkedFilePreviewItem | null;
  enableUnlockFile?: boolean;
  task?: {heading: React.ReactNode};
  insertExcerptsHandler: (excerpts: Array<ExternalFileExcerpt>, options: {replace: boolean}) => void;
  updateNoteLinkedObject: (updates: Partial<NoteLinkedFile>) => void;
  setImageFromS3Location: (
    notePartCid: string,
    previewS3Location: string | undefined,
    itemWidth: number,
    name: string,
    edits?: string
  ) => JQueryPromise<unknown> | Promise<unknown> | void;
  setNoteLinkedFileFromS3Location: (
    notePartCid: string,
    s3Location: string | undefined
  ) => JQueryPromise<unknown> | Promise<unknown> | void;
  itemWidth?: number;
  setItemWidth: (itemWidth: number) => void;
  finalizeItemWidth: (itemWidth: number) => void;
  itemId?: string | null;
  setUpdatedNoteLinkedFile: {
    bivarianceHack(noteLinkedFile: NoteLinkedFile | FromServerNoteLinkedFile): void;
  }['bivarianceHack'];
  permissions?: {admin: boolean};
  malwareContainerClassName?: string;
  imagePadding?: number;
  malwareTitleClassName?: string;
  malwareMessageClassName?: string;
  scanWarningIconClassName?: string;
  scanDangerIconClassName?: string;
  scanUnavailableBannerClassName?: string;
  scanUnavailableBannerTitleClassName?: string;
  scanUnavailableBannerDescriptionClassName?: string;
}

interface NoteLinkedFilePreviewProps extends NoteLinkedFilePreviewOwnProps {
  tfiFileMetaState: TFIFileMetaState | null;
}

interface NoteLinkedFilePreviewState {
  hasImageChanged: boolean;
  isImageSaveInFlight: boolean;
  tfiNotificationId: string;
  isImageToolbarOpen: boolean;
  imageUrl: string | null;
  imageId: string | null;
  cachedImageHeight: number | 'auto';
  isImageEditorModalOpen: boolean;
  resetCounter: number;
  stroke: string;
  fill: string;
  scanStatus: AvScanStatus | null;
  isPendingCheckoutForId?: string | null;
}

interface ScanUnavailableDownloadModalProps {
  bannerClassName?: string;
  bannerDescriptionClassName?: string;
  bannerTitleClassName?: string;
  fileName: string;
  onRequestClose: () => void;
  onRequestSubmit: (confirmed: boolean) => void;
}

interface ConfirmScanUnavailableDownloadOptions extends Omit<
  ScanUnavailableDownloadModalProps,
  'onRequestClose' | 'onRequestSubmit'
> {
  onConfirm: () => void;
}

function _openFileForEditing(tfiFileMeta: TFIFileMeta, fileId: string): void {
  openURIForEdit(tfiFileMeta.editURL!, fileId);
}

function ScanUnavailableDownloadModal({
  bannerClassName,
  bannerDescriptionClassName,
  bannerTitleClassName,
  fileName,
  onRequestClose,
  onRequestSubmit,
}: ScanUnavailableDownloadModalProps): JSX.Element {
  return (
    <Modal
      title={`Security scan unavailable for ${fileName}`}
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        onRequestSubmit(true);
      }}
      buttons={[
        {text: 'Cancel', cancel: true},
        {text: 'Download', submit: true},
      ]}
    >
      <div className={bannerClassName}>
        <div className={bannerTitleClassName}>File couldn't be scanned for security threats</div>
        <div className={bannerDescriptionClassName}>
          Benchling automatically scans files to protect against malware, but this file cannot be checked.
          <br />
          Only download if you trust the source. Contact your Benchling administrator if you have concerns.
        </div>
      </div>
    </Modal>
  );
}

ScanUnavailableDownloadModal.propTypes = {
  bannerClassName: PropTypes.string.isRequired,
  bannerDescriptionClassName: PropTypes.string.isRequired,
  bannerTitleClassName: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onRequestSubmit: PropTypes.func.isRequired,
};

function confirmScanUnavailableDownload({
  bannerClassName,
  bannerDescriptionClassName,
  bannerTitleClassName,
  fileName,
  onConfirm,
}: ConfirmScanUnavailableDownloadOptions): void {
  legacyRunModal(ScanUnavailableDownloadModal, {
    bannerClassName,
    bannerDescriptionClassName,
    bannerTitleClassName,
    fileName,
  }).then((confirmed) => {
    if (confirmed) {
      onConfirm();
    }
  });
}

function AvScanPendingPreview(): JSX.Element {
  const {isPrintPreviewView} = EditorPropertiesContext.useContext();
  return (
    <div className="note-preview-body">
      <div className="note-preview-loading">
        {!isPrintPreviewView && <CenteredHorizontalThrobber />}
        <div
          className="u-small-spacing-top"
          {...getTestProps({component: 'NoteLinkedFilePreview', element: 'scanningMessage'})}
        >
          Checking for viruses and malware
        </div>
      </div>
    </div>
  );
}

function renderStatusIconWithTooltip({
  ariaLabel,
  className,
  icon,
  tooltipText,
}: {
  ariaLabel: string;
  className?: string;
  icon: BenchlingIconProps['icon'];
  tooltipText: string;
}): JSX.Element {
  return (
    <Tooltip text={tooltipText} delay={{open: 300, close: 300}}>
      <span aria-label={ariaLabel} role="img">
        <BenchlingIcon
          icon={icon}
          className={classNames('note-icon', 'u-small-spacing-right', 'pull-left', className)}
        />
      </span>
    </Tooltip>
  );
}

function hadRecentTFIUpdate(
  props: NoteLinkedFilePreviewProps,
  nextProps: NoteLinkedFilePreviewProps
): boolean {
  const oldId = getTFIFileMeta(props.item) && getTFIFileMeta(props.item)!.id;
  const newId = getTFIFileMeta(nextProps.item) && getTFIFileMeta(nextProps.item)!.id;
  if (oldId == null || newId == null || oldId !== newId) {
    return false;
  }
  const oldRev = props.tfiFileMetaState && props.tfiFileMetaState.upstreamThirdpartyFileRev;
  const newRev = nextProps.tfiFileMetaState && nextProps.tfiFileMetaState.upstreamThirdpartyFileRev;
  if (oldRev == null || newRev == null) {
    return false;
  }
  return oldRev !== newRev;
}

function _stopPropagationForMediocreItemSelect(e: React.SyntheticEvent): void {
  e.stopPropagation();
}

// oxlint-disable-next-line react/prefer-es6-class -- createReactClass is retained for compiled JavaScript parity.
export const NoteLinkedFilePreview = createReactClass<NoteLinkedFilePreviewProps, NoteLinkedFilePreviewState>(
  // @ts-expect-error ts(2352) -- PreviewMixin supplies render and the inherited preview methods.
  {
    displayName: 'NoteLinkedFilePreview',
    propTypes: {
      fileId: PropTypes.string.isRequired,
      // The fileId of the tab that we should use to display file previews
      previewFileId: PropTypes.string,
      item: PropTypes.shape({
        // Keys from PreviewMixin
        cid: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        editURL: PropTypes.string,
        url: PropTypes.string,
        tagSchema: PropTypes.shape({
          iconId: PropTypes.string.isRequired,
        }),
        // Custom keys for NoteLinkedFilePreview
        excerptType: PropTypes.string,
        externalFile: PropTypes.object.isRequired,
        externalFileExcerpt: PropTypes.object,
        previewFile: PropTypes.object,
        missingPreviewWarning: PropTypes.string,
        isPreviewTransformed: PropTypes.bool,
        tfiFileMeta: PropTypes.shape({
          id: PropTypes.number.isRequired,
          editURL: PropTypes.string,
          tfiAccount: TFI_ACCOUNT_SHAPE.isRequired,
          thirdpartyFileRev: PropTypes.string.isRequired,
          lastSyncSuccess: PropTypes.string,
        }),
        sourcePreviewFile: PropTypes.object,
        edits: PropTypes.string,
        scanId: PropTypes.string,
        scanStatus: PropTypes.string,
      }),
      enableUnlockFile: PropTypes.bool,
      locked: PropTypes.bool.isRequired,
      placeholder: PropTypes.bool.isRequired,
      task: PropTypes.shape({heading: PropTypes.string.isRequired}),
      insertExcerptsHandler: PropTypes.func.isRequired,
      updateNoteLinkedObject: PropTypes.func.isRequired,
      setImageFromS3Location: PropTypes.func.isRequired,
      // Updates the NoteLinkedFile with the file at the given s3Location
      setNoteLinkedFileFromS3Location: PropTypes.func.isRequired,
      itemWidth: PropTypes.number,
      editorWidth: PropTypes.number.isRequired,
      setItemWidth: PropTypes.func.isRequired,
      itemId: PropTypes.string,
      setUpdatedNoteLinkedFile: PropTypes.func.isRequired,
      // From useTFIFileMetaState
      tfiFileMetaState: PropTypes.shape({
        checkingForUpdates: PropTypes.bool,
        upstreamThirdpartyFileRev: PropTypes.string,
      }),
      // Keys from PreviewMixin
      isSelected: PropTypes.bool.isRequired,
      finalizeItemWidth: PropTypes.func.isRequired,
      permissions: PERMISSIONS_SHAPE,
      notePartCid: PropTypes.string,
      malwareContainerClassName: PropTypes.string,
      imagePadding: PropTypes.number,
      malwareTitleClassName: PropTypes.string,
      malwareMessageClassName: PropTypes.string,
      scanWarningIconClassName: PropTypes.string,
      scanDangerIconClassName: PropTypes.string,
      scanUnavailableBannerClassName: PropTypes.string,
      scanUnavailableBannerTitleClassName: PropTypes.string,
      scanUnavailableBannerDescriptionClassName: PropTypes.string,
    },

    mixins: [PreviewMixin as unknown as React.Mixin<NoteLinkedFilePreviewProps, NoteLinkedFilePreviewState>],
    imageRef: null,
    _imageEditorRefs: {},

    getInitialState() {
      return {
        hasImageChanged: false, // whether the preview image has been changed since the last save
        isImageSaveInFlight: false, // is a save to the server currently in progress
        tfiNotificationId: uniqueId('tfiNotificationId'),
        isImageToolbarOpen: false,
        imageUrl: this.getImageUrl(),
        imageId: this.getImageId(),
        cachedImageHeight: 'auto',
        isImageEditorModalOpen: false,
        resetCounter: 0,
        stroke: 'black',
        fill: '',
        scanStatus: this.props.item?.scanStatus ?? null,
      };
    },

    componentDidMount() {
      this._isMounted = true;
      this._scanPollTimeout = null;
      this._scanPollAttempt = 0;
      this._scanPollInFlight = false;
      this._initialStatusFetchInFlight = false;
      this._scanPollFailureCount = 0;
      this._scanPollErrorLogged = false;
      this._registerTFIUpdateCheck(this.props);
      this._startScanPollingIfNeeded();
    },

    componentDidUpdate() {
      if (this.imageRef?.getBoundingClientRect().height) {
        this.setState({cachedImageHeight: this.imageRef?.getBoundingClientRect().height});
      }
      // If the image URL changed while the image was saving, it means that we have finished saving and received
      // the new URL from the server. Update the state to reflect this.
      if (
        this.state.isImageSaveInFlight &&
        (this.getImageUrl() !== this.state.imageUrl || this.getImageId() !== this.state.imageId)
      ) {
        this.setState({imageUrl: this.getImageUrl(), isImageSaveInFlight: false, imageId: this.getImageId()});
      }
      // If the image URL changed while the image was not saving, it means that the image was changed due to
      // upload of a new attachment
      if (this.getImageUrl() !== this.state.imageUrl || this.getImageId() !== this.state.imageId) {
        this.setState({imageUrl: this.getImageUrl(), imageId: this.getImageId()});
      }
      if (this.getEdits()) {
        this.setState({hasImageChanged: true});
      }
      this._startScanPollingIfNeeded();
    },

    UNSAFE_componentWillReceiveProps(nextProps: NoteLinkedFilePreviewProps) {
      const oldTFIFileMeta = getTFIFileMeta(this.props.item);
      const newTFIFileMeta = getTFIFileMeta(nextProps.item);
      const oldId = oldTFIFileMeta && oldTFIFileMeta.id;
      const newId = newTFIFileMeta && newTFIFileMeta.id;
      const hasNewTFI = newId != null && newId !== oldId;
      const hadOldTFI = oldId != null && newId !== oldId;
      if (hasNewTFI) {
        this._registerTFIUpdateCheck(nextProps);
      }
      if (hadOldTFI) {
        this._deregisterTFISyncCheck(this.props);
      }
      const nextScanId = nextProps.item?.scanId ?? null;
      const currentScanId = this.props.item?.scanId ?? null;
      if (nextScanId !== currentScanId) {
        this._resetScanPolling();
        this.setState({scanStatus: nextProps.item?.scanStatus ?? null});
      } else {
        const nextScanStatus = nextProps.item?.scanStatus ?? null;
        if (nextScanStatus != null && nextScanStatus !== this.state.scanStatus) {
          if (!this._isScanTerminal(this.state.scanStatus) || this._isScanTerminal(nextScanStatus)) {
            this.setState({scanStatus: nextScanStatus});
          }
        }
      }

      if (
        !this._hasUpstreamTFIChanges(nextProps) ||
        nextProps.locked ||
        this._isCheckingForUpdates(nextProps)
      ) {
        // If there are no updates, we can't update, or a sync is in progress, close any toast.
        this._closeToastForTFISync();
      } else if (hadRecentTFIUpdate(this.props, nextProps)) {
        // On page load, a TFIFileMeta isn't marked for syncing in case the change was made a while ago.
        // But, if we detect that an update happened while this component was mounted, still perform the sync.
        // NB: Avoid flux re-entrancy via action dispatch in lifecycle method
        _.defer(() => {
          this._syncTFIFile(null, nextProps);
        });
      } else {
        // If there are pending upstream changes, but we didn't pull them in automatically, notify the user.
        this._openToastForTFISync(nextProps.item);
      }
    },

    componentWillUnmount() {
      this._isMounted = false;
      this._deregisterTFISyncCheck(this.props);
      this._closeToastForTFISync();
      this._resetScanPolling();
    },

    getExternalFile() {
      if (this.props.item) {
        return this.props.item.externalFile;
      }
      return null;
    },

    getExcerpt() {
      if (this.props.item) {
        return this.props.item.externalFileExcerpt;
      }
      return null;
    },

    getExcerptFile() {
      if (this.getExcerpt()) {
        return this.getExcerpt().excerptFile;
      }
      return null;
    },

    /**
     * Return the URL of the image to be rendered with a query string added to avoid hitting the cache for
     * the same image without crossOrigin='anonymous' as this results in the image not loading (T7496)
     */
    getImageUrl() {
      const previewFile = this.getExcerptFile() || this.getImagePreviewFile();
      if (!previewFile) {
        return null;
      }
      return `${previewFile.url}?corsAnon`;
    },

    getImageId() {
      const previewFile = this.getExcerptFile() || this.getImagePreviewFile();
      if (!previewFile) {
        return null;
      }
      return previewFile.id;
    },

    /**
     * Return the previewFile attached to the externalFile if it is an image.
     */
    getImagePreviewFile() {
      const previewFile = this.getPreviewFile();
      if (previewFile && previewFile.previewType === EXTERNAL_FILE_TYPE.IMAGE) {
        return previewFile;
      }
      return null;
    },

    getEdits() {
      return this.props.item?.edits;
    },

    getPreviewFile() {
      return this.props.item?.previewFile ?? null;
    },

    getSourcePreviewFile() {
      return this.props.item?.sourcePreviewFile ?? null;
    },

    getItemType() {
      return 'preview';
    },

    _getScanId() {
      return this.props.item?.scanId ?? null;
    },

    _isAvScanEnabled() {
      return BenchlingConfig.ENABLE_ANTIVIRUS_SCANNING;
    },

    _isScanTerminal(status: AvScanStatus | null) {
      return status != null && AV_SCAN_TERMINAL_STATUSES.has(status);
    },

    _isInteractionBlocked() {
      return this._isScanning() || this._isMalwareDetected();
    },

    _isScanning() {
      return this._isAvScanEnabled() && this.state.scanStatus === 'PENDING';
    },

    _isMalwareDetected() {
      return this._isAvScanEnabled() && this.state.scanStatus === 'THREATS_FOUND';
    },

    _isCleanScanComplete() {
      return this._isAvScanEnabled() && this.state.scanStatus === 'NO_THREATS_FOUND';
    },

    _isNeverScanned() {
      return (
        this._isAvScanEnabled() &&
        (this.state.scanStatus == null || this.state.scanStatus === 'NEVER_SCANNED')
      );
    },

    _isScanUnsupportedOrFailed() {
      return (
        this._isAvScanEnabled() &&
        (this.state.scanStatus === 'UNSUPPORTED' ||
          this.state.scanStatus === 'FAILED' ||
          this.state.scanStatus === 'ACCESS_DENIED')
      );
    },

    _renderScanStatusIcon() {
      if (this._isMalwareDetected()) {
        const tooltipText =
          'Malware was detected. If you have any questions, contact Benchling at support@benchling.com';
        return renderStatusIconWithTooltip({
          ariaLabel: 'Malware detected',
          className: this.props.scanDangerIconClassName,
          icon: 'exclamation-circle',
          tooltipText,
        });
      }
      if (this._isScanUnsupportedOrFailed()) {
        const tooltipByStatus = {
          UNSUPPORTED: "This file type isn't supported by the virus scanner. Download at your own risk.",
          ACCESS_DENIED: "The virus scanner couldn't access this file. Download at your own risk.",
          FAILED: 'The virus scan failed for this file. Download at your own risk.',
        };
        const tooltipText =
          tooltipByStatus[this.state.scanStatus as keyof typeof tooltipByStatus] ??
          "We couldn't check this file for viruses. Download at your own risk.";
        return renderStatusIconWithTooltip({
          ariaLabel: 'File not scanned',
          className: this.props.scanWarningIconClassName,
          icon: 'info-circle',
          tooltipText,
        });
      }
      if (this._isNeverScanned()) {
        const tooltipText =
          'This file has not been scanned for viruses. Download it at your own risk. If you have any questions, please contact your admin.';
        return renderStatusIconWithTooltip({
          ariaLabel: 'File not scanned',
          className: this.props.scanWarningIconClassName,
          icon: 'info-circle',
          tooltipText,
        });
      }
      return null;
    },

    _resetScanPolling() {
      if (this._scanPollTimeout != null) {
        clearTimeout(this._scanPollTimeout);
        this._scanPollTimeout = null;
      }
      this._scanPollAttempt = 0;
      this._scanPollInFlight = false;
      this._initialStatusFetchInFlight = false;
      this._scanPollFailureCount = 0;
      this._scanPollErrorLogged = false;
    },

    _getNextScanPollDelayMs() {
      const attempt = this._scanPollAttempt ?? 0;
      const exponent = Math.max(0, attempt - 5);
      return Math.min(SCAN_POLL_MAX_DELAY_MS, Math.round(SCAN_POLL_BASE_DELAY_MS * 1.5 ** exponent));
    },

    _scheduleNextScanPoll() {
      if (!this._isMounted) {
        return;
      }
      if (this._scanPollTimeout != null) {
        clearTimeout(this._scanPollTimeout);
      }
      this._scanPollTimeout = setTimeout(() => {
        this._scanPollTimeout = null;
        this._pollScanStatus();
      }, this._getNextScanPollDelayMs());
    },

    _startScanPollingIfNeeded() {
      if (!this._isAvScanEnabled()) {
        this._resetScanPolling();
        return;
      }
      const scanId = this._getScanId();
      if (!scanId) {
        return;
      }
      const effectiveScanStatus = this.state.scanStatus;
      if (effectiveScanStatus == null) {
        // scanStatus is null when the component mounts before props are fully hydrated (e.g. on tab
        // navigation). Rather than assuming PENDING and showing the scanning overlay prematurely, do
        // a one-shot fetch to get the authoritative status before deciding whether to poll.
        if (!this._initialStatusFetchInFlight) {
          this._initialStatusFetchInFlight = true;
          getScanStatus(scanId)
            .then((response) => {
              // Discard the response if the component unmounted or the user navigated to a different
              // attachment (scanId changed) while the request was in-flight.
              if (!this._isMounted || this._getScanId() !== scanId) {
                return;
              }
              const fetchedStatus = response?.scanStatus;
              if (fetchedStatus == null) {
                this._scanPollAttempt += 1;
                this._scheduleNextScanPoll();
                return;
              }
              this.setState({scanStatus: fetchedStatus});
              if (this._isScanTerminal(fetchedStatus)) {
                this.props.updateNoteLinkedObject({scanStatus: fetchedStatus});
              } else {
                this._scanPollAttempt += 1;
                this._scheduleNextScanPoll();
              }
            })
            .catch(() => {
              if (!this._isMounted || this._getScanId() !== scanId) {
                return;
              }
              this._scanPollFailureCount += 1;
              if (!this._scanPollErrorLogged && this._scanPollFailureCount >= SCAN_POLL_ERROR_LOG_THRESHOLD) {
                this._scanPollErrorLogged = true;
                Logging.warn('AV scan initial status fetch failed repeatedly.', {
                  scanId,
                  attempts: this._scanPollFailureCount,
                } as Parameters<typeof Logging.warn>[1]);
              }
              this._scanPollAttempt += 1;
              this._scheduleNextScanPoll();
            })
            .finally(() => {
              this._initialStatusFetchInFlight = false;
            });
        }
        return;
      }
      if (this._isScanTerminal(effectiveScanStatus)) {
        this._resetScanPolling();
        return;
      }
      if (this._scanPollTimeout == null && !this._scanPollInFlight) {
        this._scheduleNextScanPoll();
      }
    },

    _pollScanStatus() {
      const scanId = this._getScanId();
      if (!scanId || this._scanPollInFlight) {
        return;
      }
      this._scanPollInFlight = true;
      getScanStatus(scanId)
        .then((response) => {
          if (!this._isMounted || this._getScanId() !== scanId) {
            return;
          }
          const nextStatus = response.scanStatus;
          this.setState({scanStatus: nextStatus});
          this._scanPollFailureCount = 0;
          this._scanPollErrorLogged = false;
          if (this._isScanTerminal(nextStatus)) {
            this.props.updateNoteLinkedObject({scanStatus: nextStatus});
            this._resetScanPolling();
            return;
          }
          this._scanPollAttempt += 1;
          this._scheduleNextScanPoll();
        })
        .catch(() => {
          if (!this._isMounted || this._getScanId() !== scanId) {
            return;
          }
          this._scanPollFailureCount += 1;
          if (!this._scanPollErrorLogged && this._scanPollFailureCount >= SCAN_POLL_ERROR_LOG_THRESHOLD) {
            this._scanPollErrorLogged = true;
            Logging.warn('AV scan status polling failed repeatedly.', {
              scanId,
              attempts: this._scanPollFailureCount,
            } as Parameters<typeof Logging.warn>[1]);
          }
          this._scanPollAttempt += 1;
          this._scheduleNextScanPoll();
        })
        .finally(() => {
          this._scanPollInFlight = false;
        });
    },

    _openToastForTFISync(item: NoteLinkedFilePreviewItem) {
      _.defer(() => {
        ToastActions.pushToast({
          id: this.state.tfiNotificationId,
          type: ToastType.INFO,
          message: `"${item.name}" has updates.`,
          actionText: 'Sync',
          duration: 0,
          onActionClick: () => {
            this._syncTFIFile(null, this.props);
          },
        });
      });
    },

    _closeToastForTFISync() {
      _.defer(() => {
        ToastActions.closeToast(this.state.tfiNotificationId);
      });
    },

    _registerTFIUpdateCheck(props: NoteLinkedFilePreviewProps) {
      const tfiFileMeta = getTFIFileMeta(props.item);
      if (isCurrentUserLocalSyncFile(tfiFileMeta!)) {
        _.defer(() => {
          TFIActions.registerCheckForUpdates(getTFIFileMeta(props.item)!.id);
        });
      }
    },

    _deregisterTFISyncCheck(props: NoteLinkedFilePreviewProps) {
      if (BenchlingConfig.ELN_ENABLE_DESKTOP_SYNC && getTFIFileMeta(props.item)) {
        _.defer(() => {
          TFIActions.deregisterCheckForUpdates(getTFIFileMeta(props.item)!.id);
        });
      }
    },

    _syncTFIFile(e: React.SyntheticEvent | null = null, props: NoteLinkedFilePreviewProps) {
      if (e) {
        _stopPropagationForMediocreItemSelect(e);
        e.preventDefault();
      }
      if (!this._hasUpstreamTFIChanges(props)) {
        return;
      }
      if (this._isCheckingForUpdates(props)) {
        return;
      }
      TFIActions.syncFile(getTFIFileMeta(props.item)!, props.item!.name, {
        onSuccess: (noteLinkedFile) => {
          if (this._isMounted) {
            context.using({immediateAutoSaverQueueSaveAction: ACTION_SYNC_FILE}, this, () => {
              this.props.setUpdatedNoteLinkedFile(noteLinkedFile);
            });
          }
        },
      });
    },

    _isCheckingForUpdates(props: NoteLinkedFilePreviewProps) {
      return props.tfiFileMetaState && props.tfiFileMetaState.checkingForUpdates;
    },

    _hasUpstreamTFIChanges(props: NoteLinkedFilePreviewProps) {
      const tfiFileMeta = getTFIFileMeta(props.item);
      const {tfiFileMetaState} = props;
      if (!tfiFileMetaState || !tfiFileMetaState.upstreamThirdpartyFileRev) {
        return false;
      }
      return tfiFileMetaState.upstreamThirdpartyFileRev !== tfiFileMeta!.thirdpartyFileRev;
    },

    isEditableImageFile() {
      // We currently determine if a file can be edited if it contains a preview with the IMAGE type and
      // that the file is not a gif. We look at URL to determine file type since names are user editable.
      // Technically, this may be incorrect in the future (e.g. if we generate an image preview of a PPT),
      // but is currently valid.
      return Boolean(this.getImagePreviewFile() && !this.props.item?.previewFile?.url?.endsWith('.gif'));
    },

    allowsExcerpts() {
      return Boolean(this.props.item.excerptType) && !this.props.locked;
    },

    className: 'noteLinkedFilePreview',
    noteType: NOTE_LINKED_FILE,

    /**
     * Returns the fileId of the tab that we should use to display this NoteLinkedFile preview within as a subtab.
     *
     * If the file contains a previewFileId property, then we should use that as the tabId. Otherwise, we should use the
     * fileId as the tabId.
     */
    getContainerTabId() {
      return this.props.previewFileId ?? this.props.fileId;
    },

    openItem() {
      const externalFile = this.getExternalFile();
      const previewFile = this.getPreviewFile();
      NoteLinkedFileTab.tabState.open(
        this.getContainerTabId(),
        this.props.itemId,
        this.props.item.name,
        previewFile,
        externalFile,
        this.props.item.isPreviewTransformed ?? false
      );
    },

    handleOpenExcerptModal() {
      FileExcerptModalClass.open({
        externalFile: this.getExternalFile(),
        insertExcerptsHandler: this.props.insertExcerptsHandler,

        // Don't allow multiple excerpts if we're just replacing an existing excerpt
        multiple: !this.getExcerpt(),
        name: this.props.item.name,
        owningEntityApiId: this.props.fileId,
      });
    },

    promptRenameFile() {
      if (this.props.item == null) {
        return;
      }
      const validate = (filename: string): boolean =>
        filename.length > 0 && filename.length <= MAX_NAME_LENGTH;
      modals.prompt('Rename', this.props.item.name, validate).done((resultName) => {
        this.props.updateNoteLinkedObject({name: resultName});
      });
    },

    _getEditMenuItems() {
      if (!BenchlingConfig.ELN_ENABLE_DESKTOP_SYNC) {
        return null;
      }
      if (this.getExcerptFile()) {
        return null;
      }
      const tfiFileMeta = getTFIFileMeta(this.props.item);
      if (!tfiFileMeta) {
        return {
          name: 'Checkout for Edit',
          click: this._createLocalSyncCopyAndOpenForEditing,
        };
      } else if (isLocalSyncFile(this.props.item)) {
        let tooltip;
        let disabled;
        if (!isCurrentUserLocalSyncFile(tfiFileMeta)) {
          disabled = true;
          tooltip = `File is locked by ${getPartyDisplayString(tfiFileMeta.tfiAccount.user)}`;
        } else if (this._hasUpstreamTFIChanges(this.props)) {
          disabled = true;
          tooltip = '"Sync" before making further edits';
        } else {
          disabled = false;
          tooltip = null;
        }
        return [
          {
            name: 'Edit',
            click: () => {
              _openFileForEditing(tfiFileMeta, this.props.fileId);
            },
            disabled,
            tooltip,
          },
          // TODO: Use when TFI sync is supported for all account types.
          // {
          //   name: 'Check for updates',
          //   click: () => TFIActions.updateUpstreamThirdpartyFileRev(tfiFileMeta.id),
          // },
        ];
      }
      return null;
    },

    _createLocalSyncCopyAndOpenForEditing() {
      if (this.props.enableUnlockFile) {
        this.setState({isPendingCheckoutForId: this.props.itemId});
      }
      TFIActions.createLocalSyncCopy(this.props.itemId, {
        onSuccess: (tfiFileMeta) => {
          context.using({immediateAutoSaverQueueSaveAction: ACTION_CHECKOUT_FILE}, this, () => {
            this.props.updateNoteLinkedObject({tfiFileMeta});
          });
          if (!this.props.enableUnlockFile) {
            _openFileForEditing(tfiFileMeta, this.props.fileId);
          }
        },
      });
    },

    _getDownloadClickHandler({preview}: {preview: string}): () => void {
      if (
        BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE &&
        this.props.item &&
        // eslint-disable-next-line react/prop-types
        CHEMICAL_EXTENSIONS.includes(this.props.item.documentType)
      ) {
        // eslint-disable-next-line react/prop-types
        const format = this.props.item.documentType;
        return () => {
          const download = (): Promise<unknown> =>
            chemicalStructureFromFile(this.getExternalFile(), format)
              .then((structure) => detectReaction(structure, format))
              .then((reaction) =>
                legacyRunModal(DownloadChemicalModal, {
                  filename: this.props.item.name,
                  sourceFormat: format,
                  externalFile: this.getExternalFile(),
                  reaction,
                })
              );
          if (this._isScanUnsupportedOrFailed()) {
            confirmScanUnavailableDownload({
              bannerClassName: this.props.scanUnavailableBannerClassName,
              bannerDescriptionClassName: this.props.scanUnavailableBannerDescriptionClassName,
              bannerTitleClassName: this.props.scanUnavailableBannerTitleClassName,
              fileName: this.props.item.name,
              onConfirm: download,
            });
            return;
          }
          download();
        };
      } else {
        return () => {
          const download = (): Window | null =>
            window.open(
              NoteLinkedFileDAO.getDownloadURL({
                uuid: this.props.itemId,
                name: this.props.item.name,
                preview,
              })
            );
          if (this._isScanUnsupportedOrFailed()) {
            confirmScanUnavailableDownload({
              bannerClassName: this.props.scanUnavailableBannerClassName,
              bannerDescriptionClassName: this.props.scanUnavailableBannerDescriptionClassName,
              bannerTitleClassName: this.props.scanUnavailableBannerTitleClassName,
              fileName: this.props.item.name,
              onConfirm: download,
            });
            return;
          }
          download();
        };
      }
    },

    handleContextMenu(e: React.MouseEvent<HTMLElement>) {
      if (this._isScanning() || this._isMalwareDetected()) {
        return;
      }
      // If there's no item, just don't show a context menu. This can happen while the file is
      // loading.
      if (this.props.item == null) {
        return;
      }
      // Don't override right-click menu for image to allow user to copy image
      if ($(e.target).closest('img, canvas').length) {
        return;
      }
      const options = [];
      if (!this.props.locked) {
        options.push({name: 'Rename...', click: this.promptRenameFile});
        const editMenuItems = this._getEditMenuItems();
        if (editMenuItems) {
          options.push(editMenuItems);
        }
        if (this.isEditableImageFile()) {
          options.push({
            name: 'Open Image Editor',
            click: this._openImageEditorModal,
          });
        }
        options.push('-');
      }

      if (this.props.item.isPreviewTransformed) {
        options.push({
          name: `Download`,
          click: this._getDownloadClickHandler({preview: '1'}),
        });
        options.push({
          name: `Download Original`,
          click: this._getDownloadClickHandler({preview: '0'}),
        });
      } else {
        options.push({
          name: `Download`,
          dataTestAttrs: {component: 'ContextMenu', element: 'downloadButton'},
          click: this._getDownloadClickHandler({preview: '0'}),
        });
      }
      if (this.getExcerptFile()) {
        options.push({
          name: `Download excerpt`,
          click: () => window.open(this.getExcerptFile().url),
        });
      }
      if (options.length) {
        contextmenu.view.open(e.nativeEvent, options);
      }
    },

    _openImageEditorModal() {
      this.setState({isImageEditorModalOpen: true});
      // Attempt to acquire a lock as the user is about to edit the image
      DocumentEditorLockUtil.forceAcquireLocks(this.props.fileId);
    },

    handleAddTextButtonClick(refName: string) {
      if (!this._imageEditorRefs[refName]?.isImageLoaded()) {
        return;
      }
      this._imageEditorRefs[refName].addText();
      this.setState({hasImageChanged: true});
    },

    handleAddEllipseButtonClick(refName: string) {
      if (!this._imageEditorRefs[refName]?.isImageLoaded()) {
        return;
      }
      this._imageEditorRefs[refName].addEllipse();
      this.setState({hasImageChanged: true});
    },

    handleAddArrowButtonClick(refName: string) {
      if (!this._imageEditorRefs[refName]?.isImageLoaded()) {
        return;
      }
      this._imageEditorRefs[refName].addArrow();
      this.setState({hasImageChanged: true});
    },

    handleColorChange(refName: string, type: 'fill' | 'stroke', color: string) {
      if (!this._imageEditorRefs[refName]?.isImageLoaded()) {
        return;
      }
      const fabricColor = color === COLORS.NO_STYLE ? '' : color;
      this.setState({[type]: color});
      if (this._imageEditorRefs[refName]?.changeColor(type, fabricColor)) {
        this.setState({hasImageChanged: true});
      }
    },

    handleRotateLeftButtonClick(refName: string) {
      if (!this._imageEditorRefs[refName]?.isImageLoaded()) {
        return;
      }
      this._imageEditorRefs[refName].rotateLeft();
      this.setState({hasImageChanged: true});
      analytics.deprecatedTrackEvent(ELN_ANALYTICS_ACTIONS.EDITED_IMAGE, {editAction: 'rotate_left'});
    },

    handleRotateRightButtonClick(refName: string) {
      if (!this._imageEditorRefs[refName]?.isImageLoaded()) {
        return;
      }
      this._imageEditorRefs[refName].rotateRight();
      this.setState({hasImageChanged: true});
      analytics.deprecatedTrackEvent(ELN_ANALYTICS_ACTIONS.EDITED_IMAGE, {editAction: 'rotate_right'});
    },

    handleSaveRotateButtonClick(refName: string) {
      if (!this._imageEditorRefs[refName]?.isImageLoaded()) {
        return;
      }
      this.setState({isImageSaveInFlight: true, isImageToolbarOpen: false});
      this._imageEditorRefs[refName].save(this.props.item.name).fail((res: Response) => {
        notifications.notifyError(res);
        if (!this._isMounted) {
          return;
        }
        this.setState({isImageSaveInFlight: false, hasImageChanged: true});
      });
      this.setState({hasImageChanged: false});
      analytics.deprecatedTrackEvent(ELN_ANALYTICS_ACTIONS.EDITED_IMAGE, {editAction: 'save'});
    },

    // Prevent clicking rotate buttons multiple times from triggering the doubleClick handler on 'note-item',
    // which opens the file in an external view.
    handleDoubleClick(e: React.MouseEvent) {
      e.stopPropagation();
    },

    async handleUnlock() {
      if (this.props.locked) {
        return;
      }
      const tfiFileMeta = getTFIFileMeta(this.props.item);
      const confirm = await confirmTFIUnlock(tfiFileMeta!);
      if (!confirm) {
        return;
      }
      const unlockedNLF = {
        ...this.props.item,
        tfiFileMeta: null,
        id: this.props.itemId,
      };
      this.props.setUpdatedNoteLinkedFile(unlockedNLF as NoteLinkedFile);
    },

    renderSyncIcon() {
      if (this._isInteractionBlocked()) {
        return null;
      }
      if (!BenchlingConfig.ELN_ENABLE_DESKTOP_SYNC) {
        return null;
      }

      // If there are upstream TFI changes, show a sync icon
      if (this._hasUpstreamTFIChanges(this.props)) {
        return (
          // But if the entry is locked, just inform the user that the file is out-of-sync with no CTA
          <Tooltip key="sync" text={this.props.locked ? 'Out-of-sync' : 'Sync file'}>
            <Button
              aria-label={this.props.locked ? 'Out-of-sync' : 'Sync file'}
              className={classNames('previewCTA', 'hidden-for-print', {faded: this.props.locked})}
              onClick={!this.props.locked ? () => this._syncTFIFile(null, this.props) : undefined}
              icon="refresh"
              buttonStyle={ButtonStyle.TERTIARY_BLUE}
              size={ButtonSize.MINI}
            />
          </Tooltip>
        );
      }

      // We can then show an edit icon as long as the entry is not locked.
      if (this.props.locked) {
        return null;
      }
      // We can then show an edit icon as long as the entry is not locked and the file is checked out by user.
      const tfiFileMeta = getTFIFileMeta(this.props.item);
      if (isLocalSyncFile(this.props.item) && !isCurrentUserLocalSyncFile(tfiFileMeta!)) {
        // The file is a local sync file but it is owned by someone else so we must unlock before editing.

        return null;
      }
      let clickHandler;
      if (isCurrentUserLocalSyncFile(tfiFileMeta!)) {
        // Allow directly editing the file if it is owned by the current user.
        clickHandler = () => {
          _openFileForEditing(tfiFileMeta!, this.props.fileId);
        };
      } else if (!this.props.enableUnlockFile && !isLocalSyncFile(this.props.item)) {
        // If we haven't enabled unlock, we allow editing a file if the file is not owned or is not a local
        // sync file (Google Drive, etc.).
        clickHandler = this._createLocalSyncCopyAndOpenForEditing;
      } else {
        return null;
      }
      return (
        <Tooltip key="edit-locally" text="Edit file">
          <Button
            aria-label="Edit file"
            className="previewCTA hidden-for-print"
            buttonStyle={ButtonStyle.TERTIARY_BLUE}
            size={ButtonSize.MINI}
            icon="edit"
            onClick={clickHandler}
          />
        </Tooltip>
      );
    },

    renderSyncUnlockIcon() {
      if (this._isInteractionBlocked()) {
        return null;
      }
      if (!BenchlingConfig.ELN_ENABLE_DESKTOP_SYNC || !this.props.enableUnlockFile) {
        return null;
      }
      if (this.props.locked) {
        return null;
      }
      const tfiFileMeta = getTFIFileMeta(this.props.item);
      if (!isLocalSyncFile(this.props.item)) {
        return (
          <Tooltip key="lock" text="Check out file">
            <Button
              aria-label="Check out file"
              className="previewCTA hidden-for-print"
              onClick={this._createLocalSyncCopyAndOpenForEditing}
              icon="floppy-disk-arrow-down"
              buttonStyle={ButtonStyle.TERTIARY_BLUE}
              size={ButtonSize.MINI}
            />
          </Tooltip>
        );
      } else if (isCurrentUserLocalSyncFile(tfiFileMeta!)) {
        return (
          <Tooltip key="unlock" text="Check in file...">
            <Button
              aria-label="Check in file..."
              className="previewCTA hidden-for-print"
              onClick={this.handleUnlock}
              icon="floppy-disk-arrow-up"
              buttonStyle={ButtonStyle.TERTIARY_BLUE}
              size={ButtonSize.MINI}
            />
          </Tooltip>
        );
      } else if (this.props.permissions && this.props.permissions.admin) {
        return (
          <Tooltip key="unlock" text="Unlock file..." delay={{open: 300, close: 300}}>
            <Button
              aria-label="Unlock file..."
              className="previewCTA hidden-for-print"
              onClick={this.handleUnlock}
              buttonStyle={ButtonStyle.TERTIARY_BLUE}
              size={ButtonSize.MINI}
            >
              <BenchlingIcon icon="lock" className="u-danger-color" />
            </Button>
          </Tooltip>
        );
      } else {
        const lockingUser = tfiFileMeta!.tfiAccount.user.handle;
        return (
          <Tooltip key="locked" text={`File is locked by ${lockingUser}`} delay={{open: 300, close: 300}}>
            <BenchlingIcon icon="lock" className="previewCTA hidden-for-print" />
          </Tooltip>
        );
      }
    },

    renderSyncTime() {
      const tfiFileMeta = getTFIFileMeta(this.props.item);
      if (!isLocalSyncFile(this.props.item)) {
        return null;
      }
      if (!tfiFileMeta!.lastSyncSuccess) {
        return null;
      }

      const compactTimeAgo = fuzzydate(tfiFileMeta!.lastSyncSuccess, {compact: true});
      const expandedTimeAgo = fuzzydate(tfiFileMeta!.lastSyncSuccess, {compact: false});
      return (
        <Tooltip text={`Last synced ${expandedTimeAgo}`} delay={{open: 300, close: 300}}>
          <span className="faded u-normal-font-weight">{compactTimeAgo}</span>
        </Tooltip>
      );
    },

    _isCheckingOutFileForLocalSync() {
      return this.state.isPendingCheckoutForId === this.props.itemId;
    },

    _shouldShowPostCheckoutPrompt() {
      return (
        this.state.isPendingCheckoutForId != null && this.state.isPendingCheckoutForId !== this.props.itemId
      );
    },

    renderPostCheckoutModal() {
      if (!this._shouldShowPostCheckoutPrompt()) {
        return null;
      }
      return (
        <ModalAnchor open={true}>
          <Modal
            title="Edit file"
            onRequestSubmit={() => {
              this.setState({isPendingCheckoutForId: null}, () => {
                const tfiFileMeta = getTFIFileMeta(this.props.item);
                _openFileForEditing(tfiFileMeta!, this.props.fileId);
              });
            }}
            onRequestClose={() => {
              this.setState({isPendingCheckoutForId: null});
            }}
            footer={
              BenchlingConfig.ELN_ENABLE_DESKTOP_SYNC_DOWNLOAD && (
                <p className="u-small-spacing-top">
                  To get the desktop app, visit the{' '}
                  <a target="_blank" href="/desktop">
                    download page.
                  </a>
                </p>
              )
            }
            buttons={[
              {text: 'Edit', submit: true},
              {text: 'Close', cancel: true},
            ]}
          >
            <p>
              You've checked out the file <b>{this.props.item.name}</b> for local editing. Press "Edit" below
              or the{' '}
              <a className="u-no-mouse-target">
                <BenchlingIcon icon="edit" />
              </a>{' '}
              on the attachment to open the file locally.
            </p>
            <p>
              When you're finished, click the{' '}
              <a className="u-no-mouse-target">
                <BenchlingIcon icon="file-import" />
              </a>{' '}
              icon to check the file back in to allow collaborators to edit the file.
            </p>
            {benchlingUtil.isMac() && (
              <p className="alert alert-info u-small-padding u-tiny-spacing-bottom">
                <BenchlingIcon icon="exclamation-circle" className="u-mini-spacing-right" />
                <b>Benchling Sync</b> works well with Microsoft Office, but may not work with other desktop
                applications. See{' '}
                <a href="https://help.benchling.com/hc/articles/9684279979021">
                  <u>this help article</u>
                </a>{' '}
                for more details.
              </p>
            )}
          </Modal>
        </ModalAnchor>
      );
    },

    renderHeaderIcons() {
      if (this._isCheckingForUpdates(this.props) || this._isCheckingOutFileForLocalSync()) {
        return <BenchlingIcon icon="refresh" className="glyphicon-spin" />;
      }

      if (this.getExcerptFile()) {
        return null;
      }

      return (
        <span>
          {this.renderEditIcon()}
          {this.renderCheckedOutChip()}
          {this.renderMissingPreviewWarningChip()}
          {this.renderSyncTime()}
          {this.renderSyncIcon()}
          {this.renderSyncUnlockIcon()}
          {this.renderStructureEditIcon()}
        </span>
      );
    },

    renderStructureEditIcon() {
      if (this._isInteractionBlocked()) {
        return null;
      }
      if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE) {
        return null;
      }

      const isEntryLocked = this.props.locked;
      // eslint-disable-next-line react/prop-types
      const isValidChemicalFile =
        this.props.item && CHEMICAL_EXTENSIONS.includes(this.props.item.documentType);
      const tfiFileMeta = getTFIFileMeta(this.props.item);
      const isCheckedOutByOtherUser =
        isLocalSyncFile(this.props.item) && !isCurrentUserLocalSyncFile(tfiFileMeta!);
      if (isEntryLocked || !isValidChemicalFile || isCheckedOutByOtherUser) {
        return null;
      }

      return (
        <StructureSketcherTool
          // eslint-disable-next-line react/prop-types
          fileType={this.props.item.documentType}
          fileName={this.props.item.name}
          externalFile={this.getExternalFile()}
          setNoteLinkedFileFromS3Location={this.setNoteLinkedFileFromS3Location}
        />
      );
    },

    renderCheckedOutChip() {
      if (this._isInteractionBlocked()) {
        return null;
      }
      if (!isLocalSyncFile(this.props.item)) {
        return null;
      }

      const tfiFileMeta = getTFIFileMeta(this.props.item);
      const user = isCurrentUserLocalSyncFile(tfiFileMeta!) ? 'you' : tfiFileMeta!.tfiAccount.user.name;
      return (
        <Tooltip
          key={`checked-out-chip-${this.props.item.cid}`}
          text={this.props.locked ? 'Cannot check in when entry is locked' : `Checked out by ${user}`}
          delay={{open: 300, close: 300}}
        >
          <a
            {...getTestProps({component: 'NoteLinkedFilePreview', element: 'checkedOutIndicator'})}
            className="previewCTA hidden-for-print noteEditor-noteLinkedFilePreview-chip"
            onClick={this.handleUnlock}
            style={this.props.locked ? {cursor: 'default'} : {}}
          >
            <span>Checked Out</span>
          </a>
        </Tooltip>
      );
    },

    renderMissingPreviewWarningChip() {
      if (this._isInteractionBlocked()) {
        return null;
      }
      if (!this.props.item.missingPreviewWarning) {
        return null;
      }

      return (
        <Tooltip
          key={`missing-preview-warning-chip-${this.props.item.cid}`}
          text={this.props.item.missingPreviewWarning}
          delay={{open: 300, close: 300}}
        >
          <span
            {...getTestProps({component: 'NoteLinkedFilePreview', element: 'missingPreviewIndicator'})}
            className="previewCTA hidden-for-print noteEditor-noteLinkedFilePreview-chip"
          >
            {/* If the PDF conversion (only performed on non-image files) fails, we may still have a way of
          previewing it via external file viewers. In that case we do not want to mislead users into thinking
          they cannot preview the file, but do want to highlight the fact that the PDF copy is missing. */}
            {/* eslint-disable-next-line react/prop-types */}
            {this.props.item.documentType === 'image' ? 'Not Previewable' : 'PDF Not Available'}
          </span>
        </Tooltip>
      );
    },

    renderName() {
      if (this.state.isImageToolbarOpen) {
        return null;
      }
      if (this.props.placeholder && this.props.task) {
        return this.props.task.heading;
      }
      return this.props.item.name;
    },

    _onEdit(e: React.MouseEvent) {
      e.stopPropagation();
      this.setState({isImageToolbarOpen: true});
      // Attempt to acquire a lock as the user is about to edit the image
      DocumentEditorLockUtil.forceAcquireLocks(this.props.fileId);
    },

    renderEditIcon() {
      if (this._isInteractionBlocked()) {
        return null;
      }
      if (!this.isEditableImageFile() || this.props.locked) {
        return null;
      }
      return (
        <Tooltip key="edit-image" text="Annotate image" delay={{open: 300, close: 300}}>
          <Button
            aria-label="Annotate image"
            id="edit-image-button"
            className="previewCTA hidden-for-print"
            onClick={this._onEdit}
            icon="file-pen"
            buttonStyle={ButtonStyle.TERTIARY_BLUE}
            size={ButtonSize.MINI}
          />
        </Tooltip>
      );
    },

    renderCustomTypeIcon() {
      if (this.noteType != null && !this.state.isImageToolbarOpen) {
        const scanStatusIcon = this._renderScanStatusIcon();
        if (scanStatusIcon) {
          return scanStatusIcon;
        }
        return (
          <BenchlingIcon
            icon={
              __guard__(this.props.item != null ? this.props.item.tagSchema : undefined, (x) => x.iconId) ||
              this.noteType
            }
            className="note-icon u-small-spacing-right pull-left"
          />
        );
      }
      return null;
    },

    isImageToolbarOpen() {
      return this.state.isImageToolbarOpen;
    },

    isActivelyAnnotating() {
      return this.state.isImageToolbarOpen && this.state.hasImageChanged;
    },

    handleCancel() {
      // Reset the image editor state. resetCounter is incremented such that we invalidate the image cache and
      // don't show the edited image once the user cancels their edits.
      this.setState({
        isImageToolbarOpen: false,
        hasImageChanged: false,
        resetCounter: this.state.resetCounter + 1,
      });
    },

    renderImageEditorModal(
      sourceUrl: string | null | undefined,
      sourceId: string | null | undefined,
      isSelected: boolean,
      setIsImageEditorOpen: (isOpen: boolean) => void
    ) {
      return (
        <ModalAnchor open={this.state.isImageEditorModalOpen}>
          <Modal
            title="Edit image"
            onRequestSubmit={() => {
              this.handleSaveRotateButtonClick('imageEditorModal');
              this.setState({isImageEditorModalOpen: false});
            }}
            onRequestClose={() => {
              this.setState({isImageEditorModalOpen: false});
            }}
            buttons={[
              {text: 'Cancel', cancel: true},
              {text: 'Save', submit: true},
            ]}
            fullWidth={true}
          >
            {this.renderImageToolbar(true, 'imageEditorModal')}
            <div
              style={{
                padding: '10px',
                margin: '10px',
                border: '1px grey solid',
                borderRadius: '2px',
                flex: 1,
              }}
            >
              {this.state.isImageEditorModalOpen &&
                this.renderImageEditor(
                  sourceUrl,
                  sourceId,
                  'imageEditorModal',
                  isSelected,
                  setIsImageEditorOpen
                )}
            </div>
          </Modal>
        </ModalAnchor>
      );
    },

    renderImageToolbar(isSelected: boolean, ref: string = 'imageEditor') {
      if (this.state.isImageToolbarOpen || ref === 'imageEditorModal') {
        return (
          <ImageToolbar
            isEditingDisabled={this.state.isImageSaveInFlight}
            isSavingDisabled={this.state.isImageSaveInFlight || !this.state.hasImageChanged}
            handleCancel={ref !== 'imageEditorModal' ? this.handleCancel : undefined}
            handleSaveRotateButtonClick={
              ref !== 'imageEditorModal' ? () => this.handleSaveRotateButtonClick(ref) : undefined
            }
            handleRotateLeftButtonClick={() => this.handleRotateLeftButtonClick(ref)}
            handleRotateRightButtonClick={() => this.handleRotateRightButtonClick(ref)}
            handleAddTextButtonClick={() => this.handleAddTextButtonClick(ref)}
            handleAddEllipseButtonClick={() => this.handleAddEllipseButtonClick(ref)}
            handleAddArrowButtonClick={() => this.handleAddArrowButtonClick(ref)}
            handleChangeColorButtonClick={(type, color) => this.handleColorChange(ref, type, color)}
            stroke={this.state.stroke === COLORS.NO_STYLE ? 'transparent' : this.state.stroke}
            fill={this.state.fill === COLORS.NO_STYLE ? 'transparent' : this.state.fill}
          />
        );
      } else {
        return null;
      }
    },

    renderNameExtra(isSelected: boolean) {
      if (this.getExcerpt()) {
        return (
          <div className="faded u-tiny-spacing-top">{`p. ${this.getExcerpt().referenceOffset + 1}`}</div>
        );
      }
      return null;
    },

    renderOpenExtra() {
      if (this._isInteractionBlocked()) {
        return null;
      }
      if (!this.props.locked && (this.getExcerpt() || this.allowsExcerpts())) {
        const fileSize = this.props.item.externalFile?.fileSize ?? 0; // Default to 0 if undefined
        const isFileSizeValid = fileSize <= MAX_FILE_SIZE_FOR_PREVIEW_BYTES;
        const excerptText = this.getExcerpt() ? 'Replace excerpt' : 'Insert excerpts';
        const tooltipText = isFileSizeValid ? excerptText : `File too large to insert excerpts`;
        return (
          <Tooltip key="excerpt" text={tooltipText} delay={{open: 300, close: 300}}>
            <Button
              aria-label={tooltipText}
              key="excerpt"
              className="previewCTA hidden-for-print"
              buttonStyle={ButtonStyle.TERTIARY_BLUE}
              size={ButtonSize.MINI}
              icon="leaf"
              onClick={this.handleOpenExcerptModal}
              disabled={!isFileSizeValid}
            />
          </Tooltip>
        );
      }
      return null;
    },

    setImageFromS3Location(previewS3Location: string | undefined, itemWidth: number, edits?: string) {
      this.props.setImageFromS3Location(
        this.props.notePartCid,
        previewS3Location,
        itemWidth,
        this.props.item.name,
        edits
      );
    },

    setNoteLinkedFileFromS3Location(s3Location: string | undefined) {
      this.props.setNoteLinkedFileFromS3Location(this.props.notePartCid, s3Location);
    },

    setItemHeight(height: number) {
      this.setState({cachedImageHeight: height});
    },

    _getRenderedImageWidth() {
      const padding = this.props.imagePadding ?? MEDIOCRE_TOTAL_IMAGE_PADDING;
      let imageWidth = this.props.itemWidth - padding;
      // If the itemWidth isn't set, that must mean that the item spans 100% of the left table cell,
      // which has width `this.props.editorWidth / 2`.
      if (!this.props.itemWidth) {
        imageWidth = this.props.editorWidth / 2 - padding;
      }
      return imageWidth;
    },

    _setImageEditorRef(refName: string, element: React.ComponentRef<typeof ImageEditorWrapper> | null) {
      this._imageEditorRefs[refName] = element;
    },

    renderImageEditor(
      sourceUrl: string | null | undefined,
      sourceId: string | null | undefined,
      refName: string,
      isSelected: boolean,
      setIsImageEditorOpen: (isOpen: boolean) => void
    ) {
      return (
        <ImageEditorWrapper
          // ImageEditor doesn't currently support changing URLs. So we force it to remount on
          // url change by setting the key as imageUrl. Each time the reset counter is updated, this creates
          // a new key and forces the image to be remounted by invalidating the cached image.
          key={`${sourceUrl}-${this.state.resetCounter}`}
          url={sourceUrl!}
          id={sourceId!}
          setImageFromS3Location={this.setImageFromS3Location}
          imageWidth={this._getRenderedImageWidth()}
          setItemWidth={this.props.setItemWidth}
          setItemHeight={this.setItemHeight}
          imagePadding={this.props.imagePadding}
          finalizeItemWidth={this.props.finalizeItemWidth}
          ref={(element) => {
            this._setImageEditorRef(refName, element);
          }}
          isImageSaving={this.state.isImageSaveInFlight}
          owningEntityApiId={this.props.fileId}
          stroke={this.state.stroke === COLORS.NO_STYLE ? '' : this.state.stroke}
          fill={this.state.fill === COLORS.NO_STYLE ? '' : this.state.fill}
          isSelected={isSelected}
          setIsImageEditorOpen={setIsImageEditorOpen}
          edits={this.getEdits()}
        />
      );
    },

    _getCachedImageHeight() {
      return this.state.isImageToolbarOpen ? 'auto' : this.state.cachedImageHeight;
    },

    _getSourcePreviewFileUrl() {
      return this.getSourcePreviewFile()?.url ? `${this.getSourcePreviewFile().url}?corsAnon` : undefined;
    },

    _getSourcePreviewFileId() {
      return this.getSourcePreviewFile()?.id ?? undefined;
    },

    renderWithSignedUrl(signedURL: string | null | undefined) {
      if (signedURL === undefined) {
        return (
          <div
            {...loadingIndicatorAttrs()}
            {...getTestProps({component: 'NoteLinkedFilePreview', element: 'previewLoadingSkeleton'})}
            className="noteLinkedFilePreviewImg"
            // Benchling paragraph tag default margin to 10px on the bottom
            // To preserve the cachedImageHeight properly we set the margin to 0
            style={{
              height: this._getCachedImageHeight(),
              margin: '0px',
            }}
          >
            <div className="note-preview-loading">
              <CenteredHorizontalThrobber />
              <div className="u-small-spacing-top">Creating preview</div>
            </div>
          </div>
        );
      }
      // eslint-disable-next-line benchlint/no-eqeqeq-null
      if (signedURL === null) {
        return <p className="noteLinkedFilePreviewImg">Error loading file</p>;
      }
      return (
        <img
          // Set crossOrigin so that the response header contains Access-Control-Allow-Origin.
          // This header field is not necessary for the <img> tag, but it is necessary for
          // the image to be loaded onto the canvas in the ImageEditor, and the response may be cached.>
          crossOrigin="anonymous"
          ref={(imageRef) => {
            this.imageRef = imageRef;
          }}
          onLoad={(event) => {
            this.setState({
              cachedImageHeight: (event.target as HTMLImageElement).getBoundingClientRect().height,
            });
          }}
          src={signedURL}
          className="noteLinkedFilePreviewImg"
          alt="thumbnail"
          // @ts-expect-error ts(2322) -- Legacy EFL markup attribute is not on the img DOM type.
          efl_identifier={this.state.imageId} // eslint-disable-line react/no-unknown-property
          {...getTestProps({component: 'NoteLinkedFilePreview', element: 'image', key: this.state.imageId})}
          data-amp-safe={false}
        />
      );
    },

    renderItem(isSelected: boolean) {
      if (this._isAvScanEnabled() && this._isMalwareDetected()) {
        return (
          <div className="note-preview-body">
            <div
              className={classNames('noteLinkedFilePreview-malwareTitle', this.props.malwareTitleClassName)}
              {...getTestProps({component: 'NoteLinkedFilePreview', element: 'malwareTitle'})}
            >
              Malware detected
            </div>
            <div
              className={classNames(
                'noteLinkedFilePreview-malwareMessage',
                this.props.malwareMessageClassName
              )}
              {...getTestProps({component: 'NoteLinkedFilePreview', element: 'malwareMessage'})}
            >
              We detected malware in this file and blocked access to it.
            </div>
          </div>
        );
      }
      if (this._isAvScanEnabled() && this._isScanning()) {
        return <AvScanPendingPreview />;
      }
      const cleanScanTestProps = this._isCleanScanComplete()
        ? getTestProps({component: 'NoteLinkedFilePreview', element: 'cleanScanComplete'})
        : {};
      const imageUrl = this.state.imageUrl ?? this.getImageUrl();
      const imageId = this.state.imageId ?? this.getImageId();
      const sourceUrl = this._getSourcePreviewFileUrl() ?? imageUrl;
      const sourceId = this._getSourcePreviewFileId() ?? imageId;
      // If the image is editable, show the image editor on hover if the isImageToolbarOpen state is true or if
      // the image is currently saving
      const showImageEditor =
        imageUrl && imageId && (this.state.isImageSaveInFlight || this.state.isImageToolbarOpen);
      return (
        <CaptionEditableItemContext.Consumer>
          {({setIsImageEditorOpen}) => (
            <div
              className={classNames({
                'note-preview-body': imageUrl != null,
                'u-position-relative': showImageEditor,
              })}
              {...cleanScanTestProps}
            >
              {this.renderImageEditorModal(sourceUrl, sourceId, isSelected, setIsImageEditorOpen)}
              {this.renderPostCheckoutModal()}
              {showImageEditor &&
                this.renderImageEditor(sourceUrl, sourceId, 'imageEditor', isSelected, setIsImageEditorOpen)}
              {/**
             Render the SignedExtFileURLProxy only when a image URL is
             available and:
             - the image editor is still loading and the toolbar is open OR
             - the image editor is done and the toolbar is closed
             */}
              {imageUrl &&
                ((!this._imageEditorRefs?.imageEditor?.isImageLoaded() && this.state.isImageToolbarOpen) ||
                  (!this.state.isImageToolbarOpen && !this.state.isImageSaveInFlight)) && (
                  <SignedExtFileURLProxy
                    url={imageUrl}
                    externalFileId={imageId}
                    owningEntityApiId={this.props.fileId}
                    renderWithSignedURL={this.renderWithSignedUrl}
                    returnBase64={true}
                  />
                )}
            </div>
          )}
        </CaptionEditableItemContext.Consumer>
      );
    },

    getItemClassName() {
      if (this._isMalwareDetected()) {
        return classNames('noteLinkedFilePreview--malware', this.props.malwareContainerClassName);
      }
      return null;
    },

    isOpenDisabled() {
      return this._isScanning() || this._isMalwareDetected();
    },
  } as React.ComponentSpec<NoteLinkedFilePreviewProps, NoteLinkedFilePreviewState>
);

function __guard__<T, U>(value: T | null | undefined, transform: (value: T) => U): U | undefined {
  return value != null ? transform(value) : undefined;
}

const useStyles = createStyles((theme) => ({
  malwareContainer: {
    border: `1px solid ${theme.colors.red[6]} !important`, // TODO(BNCH-143937): remove !important after less to mantine conversion
    backgroundColor: `${theme.colors.red[0]} !important`, // TODO(BNCH-143937): remove !important after less to mantine conversion
  },
  malwareTitle: {
    color: theme.colors.red[6],
  },
  malwareMessage: {
    color: theme.colors.gray[6],
  },
  scanWarningIcon: {
    color: `${theme.colors.gray[5]} !important`, // TODO(BNCH-144084): migrate note-preview.less to mantine
  },
  scanDangerIcon: {
    color: `${theme.colors.red[5]} !important`, // TODO(BNCH-144084): migrate note-preview.less to mantine
  },
  scanUnavailableBanner: {
    borderLeft: `4px solid ${theme.colors.orange[5]}`,
    backgroundColor: theme.colors.orange[0],
    borderRadius: theme.radius.sm,
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  scanUnavailableBannerTitle: {
    fontWeight: 600,
  },
  scanUnavailableBannerDescription: {
    color: theme.colors.dark[6],
  },
}));

function StyledNoteLinkedFilePreview(props: NoteLinkedFilePreviewOwnProps): JSX.Element {
  const {classes} = useStyles();
  const tfiFileMetaState = useTFIFileMetaState(getTFIFileMeta(props.item)?.id);
  return (
    <NoteLinkedFilePreview
      {...props}
      tfiFileMetaState={tfiFileMetaState}
      malwareContainerClassName={classes.malwareContainer}
      malwareTitleClassName={classes.malwareTitle}
      malwareMessageClassName={classes.malwareMessage}
      scanDangerIconClassName={classes.scanDangerIcon}
      scanWarningIconClassName={classes.scanWarningIcon}
      scanUnavailableBannerClassName={classes.scanUnavailableBanner}
      scanUnavailableBannerTitleClassName={classes.scanUnavailableBannerTitle}
      scanUnavailableBannerDescriptionClassName={classes.scanUnavailableBannerDescription}
    />
  );
}

export default StyledNoteLinkedFilePreview;
